// SHOP-8528: file to be removed
import { useMutation } from '@tanstack/react-query';
import { env } from 'lib/constants/env';

const CREATE_SUBSCRIBE_SIGNUP_KEY = 'createSubscribeSignup';

interface Attributes {
  slug: string;
}

type SubscribeV2Props =
  | {
      email: string;
      phoneNumber?: never;
      profileId?: string;
      attributes: Attributes;
    }
  | {
      email?: never;
      phoneNumber: string;
      profileId?: string;
      attributes: Attributes;
    }
  | {
      email: string;
      phoneNumber: string;
      profileId?: string;
      attributes: Attributes;
    };

const createSubscribeSignup = async ({
  email,
  phoneNumber,
  profileId,
  attributes,
}: SubscribeV2Props) => {
  try {
    const response = await fetch(
      `${env.NEXT_PUBLIC_TIMELINE_API}/subscribe-v2`,
      {
        method: 'post',
        body: JSON.stringify({
          email,
          phoneNumber,
          profileId,
          attributes: {
            slug: attributes.slug,
            environment: env.NEXT_PUBLIC_VERCEL_ENV,
          },
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    if (!response.ok) {
      throw new Error(
        response.statusText,
        response as ErrorOptions | undefined,
      );
    }

    return response;
  } catch (error) {
    console.error(error);
    throw new Error('Subscribe failed');
  }
};

export const useSubscribeSignup = () =>
  useMutation({
    mutationKey: [CREATE_SUBSCRIBE_SIGNUP_KEY],
    mutationFn: createSubscribeSignup,
  });
